import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const DEACTIVATE_CAMPAIGN_URL = '/campaigns/deactivateTriggered';

export const useDeactivateCampaignMutation = () => {
  const { isLoading, mutate, error } = useRestMutation(DEACTIVATE_CAMPAIGN_URL, ApiMethod.post);
  return { isLoading, mutate, error };
};
